<!-- header -->
<nz-page-header nzBackIcon (nzBack)="goToBack()">
  <nz-page-header-title>
    <i class="fal fa-box-full"></i>
    {{'Catalog' | translate}}
  </nz-page-header-title>
  <nz-page-header-extra>
    <nz-space nzSize="large">
      <ng-container *nzSpaceItem>
        <!-- <button *nzSpaceItem nz-button nzType="default" (click)="openColumnsDrawer()">
          <span nz-icon nzType="table" nzTheme="outline"></span>
          <span>Columns</span>
        </button> -->

        <div *ngIf="mode==='edit'">
           <!-- <button nz-button nzType="default" type="submit" (click)="addProductsToCatalog()"
           style="margin-inline-end: 8px;">
            {{'Add Products' | translate}}
          </button> -->

          <button nz-button nzType="primary" type="submit" (click)="updateCatalog()">
            {{'Update Catalog' | translate}}
          </button>

           
        </div>
        <div *ngIf="mode==='create'">
          <button nz-button nzType="primary" (click)="addCatalog()">{{'Submit' | translate}}</button>
        </div>
      </ng-container>
    </nz-space>
  </nz-page-header-extra>
</nz-page-header>

<div class="layout-container">
  <!-- Form  -->
  <div class="form-wrapper">

    <form [formGroup]="catalogForm" nzLayout="vertical">

      <nz-form-label class="custom-label" [nzFor]="'shareableLink'">Sharable link</nz-form-label>
      <nz-form-item>
        <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
          <input type="text" nz-input formControlName="shareableLink" readonly />
        </nz-input-group>
      </nz-form-item>
      <ng-template #suffixIconButton>

        <button [disabled]="mode === 'create'" (click)="copyToClipboard()" nz-button nzType="default"
          class="custom-button" nzSearch>
          <i *ngIf="isCopied; else copyIcon" class="fas fa-check"></i>
          <ng-template #copyIcon>
            <i class="fas fa-copy"></i>
          </ng-template>
        </button>
      </ng-template>



      <nz-form-item>
        <nz-form-label class="custom-label" [nzFor]="'name'">{{'Name Catalog' | translate}}</nz-form-label>
        <nz-form-control
        
   [nzErrorTip]="
      catalogForm.controls['name'].invalid &&
      (catalogForm.controls['name'].dirty ||
       catalogForm.controls['name'].touched)
        ? 'Name is required and must be at least 2 characters.'
        : undefined
    "
>
          <input nz-input formControlName="name" [placeholder]="'Enter Catalog Name'" required />
          
        </nz-form-control>
      </nz-form-item>


      <nz-form-item>
        <nz-form-label class="custom-label" [nzFor]="'description'">{{'Description Catalog' |
          translate}}</nz-form-label>
        <nz-form-control
    [nzErrorTip]="
      catalogForm.controls['description'].invalid &&
      (catalogForm.controls['description'].dirty ||
       catalogForm.controls['description'].touched)
        ? 'Description is required and must be at least 2 characters.'
        : undefined
    "
        >
          <textarea nz-input formControlName="description" rows="3" [placeholder]="'Enter description'"
            required></textarea>
        </nz-form-control>
      </nz-form-item>



      <nz-list-item-meta-title class="custom-label">{{'Attributes' | translate}}</nz-list-item-meta-title>
      <nz-list-item-meta-description style="width: 65%">
        <nz-form-control nz-col nzSpan="24" style="margin-bottom: 16px;">
          <nz-select nz-col nzSpan="24" formControlName="availableAttributes" nzMode="multiple" nzShowSearch
            nzAllowClear [nzPlaceHolder]="'Search for attributes ...'">
            <nz-option *ngFor="let option of attributes" [nzLabel]="option.Label" [nzValue]="option.Id">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-list-item-meta-description>




      <ng-container *ngFor="let prop of properties">
        <nz-list-item-meta>
          <nz-list-item-meta-title class="custom-label">{{ prop.title | translate }}</nz-list-item-meta-title>
          <nz-list-item-meta-description style="width: 65%">
            <nz-form-control nz-col nzSpan="24" style="margin-bottom: 16px;">
              <nz-select [formControlName]="prop.formControlName" nzShowSearch nzAllowClear
                [nzPlaceHolder]="'Search for attributes ...' | translate">
                <nz-option *ngFor="let option of attributes" [nzLabel]="option.Label"
                  [nzValue]="option.Name"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-list-item-meta-description>
        </nz-list-item-meta>
      </ng-container>

      <nz-list-item-meta>
        <nz-list-item-meta-title class="custom-label">{{'Currency' | translate}}</nz-list-item-meta-title>
        <nz-list-item-meta-description style="width: 65%">
          <nz-form-control nz-col nzSpan="24" style="margin-bottom: 16px;">
            <nz-select [formControlName]="'currency'" nzShowSearch nzAllowClear
              [nzPlaceHolder]="'Search for currency ...' | translate">
              <nz-option *ngFor="let option of currencies" 
              [nzLabel]="option.isoCode"
                [nzValue]="option.isoCode"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-list-item-meta-description>
      </nz-list-item-meta>

    </form>

    <!-- Images  -->
  <ng-container *ngIf="mode === 'edit'">
  <!-- Thumbnail Image Upload -->
  <label class="upload-label custom-label">
    {{'Thumbnail Image' | translate}}
  </label>

  <div class="upload-btn-wrapper custom-Thumnail"
    [ngStyle]="{ 'background-image': previewImageUrl || thumbUrl ? 'url(' + (previewImageUrl || thumbUrl) + ')' : 'none' }"
    [class.image-uploaded]="previewImageUrl || thumbUrl">

    <a *ngIf="!previewImageUrl && !thumbUrl" nz-button (click)="normalUpload.click()" nzType="default" class="upload-button">
      <i class="fas fa-upload"></i>&nbsp; {{'Upload Thumbnail' | translate}}
    </a>

    <input #normalUpload type="file" id="normal-input-file" style="display: none" multiple accept="image/*"
      (change)="onFileSelected($event)" />
    <div class="action-buttons">
      <button *ngIf="thumbUrl || previewImageUrl" nz-button nzType="default" class="delete-button"
        (click)="removeImage('Normal')">
        <i class="fas fa-trash"></i>&nbsp;
      </button>
      <button *ngIf="thumbUrl" class="preview-button" nz-button nzType="default" (click)="previewImage(ImageType.Normal,'')">
        <i nz-icon nzType="eye" nzTheme="outline"></i>&nbsp;
      </button>
    </div>
  </div>

  <!-- Banner Image Upload -->
  <label class="upload-label custom-label">
    {{'Banner Image' | translate}}
  </label>

  <div class="upload-btn-wrapper custom-banner"
    [ngStyle]="{ 'background-image': previewBannerUrl || bannerUrl ? 'url(' + (previewBannerUrl || bannerUrl) + ')' : 'none' }"
    [class.image-uploaded]="previewBannerUrl || bannerUrl">

    <a *ngIf="!previewBannerUrl && !bannerUrl" nz-button (click)="bannerUpload.click()" nzType="default"
      class="upload-button">
      <i class="fas fa-upload"></i>&nbsp; {{'Upload Banner' | translate}}
    </a>

    <input #bannerUpload type="file" id="banner-input-file" style="display: none" multiple accept="image/*,video/*"
      (change)="onFileSelected($event, 'Banner')" />
    <div class="action-buttons">
      <button *ngIf="bannerUrl || previewBannerUrl" nz-button nzType="default" class="delete-button"
        (click)="removeImage('Banner')">
        <i class="fas fa-trash"></i>&nbsp;
      </button>
      <button *ngIf="bannerUrl" nz-button nzType="default" class="preview-button" (click)="previewImage(ImageType.Banner,'')">
        <i nz-icon nzType="eye" nzTheme="outline"></i>&nbsp;
      </button>
    </div>
  </div>
</ng-container>

  </div>



  <div class="catalog-type-and-table">
    <!-- Tabs Catalog Type -->
    <div style="margin-right: 10px;" *ngIf="tabIndex!=''">
      <app-dynamic-catalog
      [objectType]="20"
      [tabIndex]="tabIndex" (tabIndexChange)="onTabIndexChange($event)" [mode]="mode"
        [catalogId]="catalogId" (products)="receiveProducts($event)" (filter)="receiveFilter($event)"
        (clearConditionEvent)="handleClearCondition()"
        (isLoadingProduct)="onLoadingChanged($event)"></app-dynamic-catalog>
    </div>
    <!-- <app-dynamic-catalog [mode]="mode" (filtersChanged)="updateCatalogFilters($event)"></app-dynamic-catalog> -->
    <!-- Table display Products -->
    <div class="table-wrapper">
      <div class="table-header">


        <nz-input-group nzSearch [nzAddOnAfter]="searchButton">
          <input type="text" [(ngModel)]="searchValue" (ngModelChange)="onSearch()" nz-input
            placeholder="search name or sku" />
        </nz-input-group>

        <ng-template #searchButton>

          <button (click)="onSearch()" nz-button nzType="default" nzSearch>
            <i class="fas fa-search"></i>
          </button>
        </ng-template>
      
     <ng-container *ngIf="!(tabIndex === 'Smart')">
  <button nz-button class="add-button" (click)="openProductSelector()">
    <span nz-icon nzType="plus" nzTheme="outline"></span>
    {{ 'Add new products' | translate }}
  </button>
</ng-container>

        
        <ng-container *ngIf="tabIndex=='Manual'">
        <button nz-button nzType="primary" nzDanger
        (click)="bullkDelete()" 
        [disabled]="setOfCheckedIds.size ===0"
        >{{'Delete' | translate}}</button>
        </ng-container>

      </div>
   
    <div *ngIf="productsLoading" 
        style="display: flex; justify-content: center; align-items: center; height: 200px;">
      <nz-spin nzSimple nzSize="large"></nz-spin>
    </div>

<nz-spin
  *ngIf="loadingProduct"
  nzSimple
  style="display: flex; justify-content: center; align-items: center; height: 200px;">
</nz-spin>

<!-- Tables Products-->
 <ng-container   *ngIf="!loadingProduct">
      <nz-table #productTable
       [nzData]="displayedProducts" 
       [nzBordered]="true"
        [nzShowPagination]="true"
        [nzShowSizeChanger]="hideSizeChanger"
        [nzFrontPagination]="isFrontPagination"
        [nzTotal]="productsCatalog?.productCount || 0"
         [nzPageIndex]="productTableParams.index"
        [nzPageSize]="productTableParams.size" 
        (nzPageSizeChange)="onPageSizeChange($event)"
        (nzPageIndexChange)="onPageChange($event)" 
        *ngIf="!productsLoading"
        [nzSize]="'middle'"
       

        >
        <thead>
          <tr>
            <ng-container *ngIf="!(tabIndex === 'Smart')">
       <th id="th-selectable" [nzWidth]="'50px'" [nzLeft]="true" [nzSelections]="listOfSelection"
        [(nzChecked)]="checked" [nzIndeterminate]="indeterminate">
        </th>
        </ng-container>
            <th nzWidth="10%" style="text-align:center;">{{'Image' | translate}}</th>
            <th nzWidth="35%">{{'Sku' | translate}}</th>
            <th nzWidth="35%">{{'Name' | translate}}</th>
            <th nzWidth="10%" class="text-right">{{'Price' | translate}}</th>
            <th nzWidth="6%" *ngIf="tabIndex=='Manual'">{{'Action' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of productTable.data">
            
<ng-container *ngIf="!(tabIndex === 'Smart')">
      <td>
        <label nz-checkbox id="td-selectable"
         [nzChecked]="setOfCheckedIds.has(data.id)"
    (nzCheckedChange)="selection(data.id)"
    style="margin: 15px"
    ></label>
    
  </td>
      </ng-container>
            <td class="container">
              <img [src]="(data.mainImage ? data.mainImage : '../../../assets/defaultProductImage.png') | safeHtml:'url'"
              alt="Image"
              class="centered-element"
              (click)="previewImage(ImageType.Product ,data.mainImage)" />

            </td>
            <td>
              <a [routerLink]="['/product', data.id]" [queryParams]="{ activePage: 'categories' }">
                {{ data.sku }}
              </a>
            </td>
            <td>
              <a [routerLink]="['/product', data.id]" [queryParams]="{ activePage: 'categories' }">
                {{ data.name }}
              </a>
            </td>
          
            <td class="text-right"> 
              <!-- {{ data.price ? data.price +'  '+ productsCatalog.currency : '' }} -->
             {{ data.price | priceFormat:productsCatalog?.currency }}
            </td>
 
            <td style="text-align: center;" *ngIf="tabIndex=='Manual'">
              <a nz-button nzType="text" nzDanger nz-popconfirm
                [nzPopconfirmTitle]="'Are you sure delete this product?' | locale"
                (nzOnConfirm)="deleteProduct(data.id)" style="background: none;">
                <span class="delete" nz-icon nzType="delete" nzTheme="outline">

                </span>
              </a>
            </td>
          </tr>
        </tbody>
      </nz-table>
</ng-container>
    </div>
  </div>
</div>


<app-product-selector [savedFilters]="savedFilters"
 (filtersChanged)="handleFilterChanges($event)"
  (productsSelected)="handleProductSelection($event)"
   (getProducts)="refreshDrawerProducts()"
  [listColumns]="listColumns"
   [productsPayload]="drawerPayload"
    [preSelectedProducts]="selectedProductsOld2">
</app-product-selector>